import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ArrowLeft } from '@element-plus/icons-vue'

interface item {
  name?: string
  path?: string
  route?: RouteLocationRaw
  routeName?: string
  backFunc?: () => void
}


import { defineComponent, defineProps, PropType } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'
const __default__ = defineComponent({
  name: 'DetailHeader',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    required: true,
    type: Object as PropType<item>,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()



const goBack = () => {
  const {
    item: { routeName, path, backFunc, route },
  } = props
  if (route) {
    router.push(route)
  } else if (path) {
    router.push({ path })
  } else if (routeName) {
    router.push({ name: routeName })
  } else if (backFunc) {
    backFunc()
  } else {
    router.back()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!

  return (_openBlock(), _createBlock(_component_el_page_header, {
    class: "detail-header",
    icon: _unref(ArrowLeft),
    content: __props.item.name,
    onBack: goBack
  }, _createSlots({ _: 2 }, [
    (_ctx.$slots.content)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ])
        }
      : undefined
  ]), 1032, ["icon", "content"]))
}
}

})